import { useRef, useState, useEffect, useCallback } from 'react';
import logger from '../logger';
import { loadScript } from '../utils';
const SCRIPT_ID = 'google-gsi-lib';
const SCRIPT_SRC = 'https://accounts.google.com/gsi/client';
export default function useGoogleSignIn(clientId, lazyload, view, onSuccess) {
    const buttonRef = useRef(null);
    const doneRef = useRef(false);
    const [loaded, setLoaded] = useState(false);
    const [canLoadSdk, setCanLoadSdk] = useState(lazyload ? false : true);
    useEffect(()=>{
        var _window_google_accounts, _window_google;
        if (!canLoadSdk) {
            return;
        }
        if (!loaded) {
            loadScript(SCRIPT_ID, SCRIPT_SRC, ()=>setLoaded(true));
            return;
        }
        if (!buttonRef.current || typeof ((_window_google = window.google) === null || _window_google === void 0 ? void 0 : (_window_google_accounts = _window_google.accounts) === null || _window_google_accounts === void 0 ? void 0 : _window_google_accounts.id) === 'undefined' || doneRef.current === true) {
            return;
        }
        window.google.accounts.id.initialize({
            client_id: clientId,
            callback: (response)=>{
                logger.info('Google Auth response', response);
                onSuccess(response);
            }
        });
        window.google.accounts.id.renderButton(buttonRef.current, {
            type: view,
            theme: 'outline',
            size: 'large',
            text: 'continue_with',
            logo_alignment: 'left',
            width: view === 'standard' ? buttonRef.current.clientWidth : undefined
        });
        doneRef.current = true;
    }, [
        loaded,
        clientId,
        onSuccess,
        canLoadSdk,
        view
    ]);
    const triggerLazyload = useCallback(()=>{
        setCanLoadSdk(true);
    }, []);
    return {
        buttonRef,
        triggerLazyload
    };
}

//# sourceMappingURL=useGoogleSignIn.js.map